export const CSS = {
  thumbnail: "thumbnail",
  background: "background",
  initials: "initials",
  icon: "icon",
};
